import {getFormattedDate} from "../../../CommonFunctions";
import React, {useMemo, useState} from "react";
import {FarmDialogGraph} from "../charts/FarmDialogGraph";
import {getFilterChangeGapFromToday} from "../../../../services/FarmService";
import {getFormattedPmValue, getFormattedRowVocValue} from "../../../../api/apiInfluxdb";
import {useSmartFarmData} from "../../../../contexts/SmartFarmDataContext";
import {postFilterChange} from "../../../../api/apiFarmCommand";
import {AlertMessage} from "../../../common/AlertMessage";

export const PollutionBlock = (props) => {

    const {systemCode, farmCell} = props;
    const {smartFarmData, smartFarmDataHistory, unitPeriod} = useSmartFarmData();

    // Format data
    const pm2_5Value = smartFarmData?.[systemCode]?.pm2_5;
    const pm2_5 = pm2_5Value ? pm2_5Value : null;
    const pm2_5ListValue = smartFarmDataHistory?.[systemCode]?.pm2_5;
    const pm2_5List = (pm2_5ListValue === undefined || pm2_5ListValue === null) ? [] : pm2_5ListValue.map(point => [point[0], getFormattedPmValue(point[1])]);
    const pm10Value = smartFarmData?.[systemCode]?.pm10;
    const pm10 = pm10Value ? pm10Value : null;
    const pm10ListValue = smartFarmDataHistory?.[systemCode]?.pm10;
    const pm10List = (pm10ListValue === undefined || pm10ListValue === null) ? [] : pm10ListValue.map(point => [point[0], getFormattedPmValue(point[1])]);
    const co2Value = smartFarmData?.[systemCode]?.co2;
    const co2 = co2Value ? co2Value : null;
    const co2ListValue = smartFarmDataHistory?.[systemCode]?.co2;
    const co2List = (co2ListValue === undefined || co2ListValue === null) ? [] : co2ListValue.map(point => [point[0], getFormattedPmValue(point[1])]);
    const rawVocValue = smartFarmData?.[systemCode]?.raw_voc_int;
    const rawVoc = rawVocValue ? rawVocValue : null;
    const rawVocListValue = smartFarmDataHistory?.[systemCode]?.raw_voc_int;
    const rawVocList = (rawVocListValue === undefined || rawVocListValue === null) ? [] : rawVocListValue.map(point => [point[0], getFormattedRowVocValue(point[1])]);

    const [alert, setAlert] = useState();
    const [fanChangeFormVisible, setFanChangeFormVisible] = useState(false);
    const [fanChangeCode, setFanChangeCode] = useState('');

    const isFilterChangeNeeded = (filterChangeDate) => {
        // Today at midnight
        const todayAtMidnight = (new Date()).setHours(0, 0, 0, 0);
        // filter change date at midnight
        const filterChangeAtMidnight = (new Date(filterChangeDate * 1000)).setHours(0, 0, 0, 0);

        // need change if difference < 1 day
        return filterChangeAtMidnight - todayAtMidnight < 3600 * 24 * 1000;
    }

    const needFilterChange = farmCell.next_filter_change_date ? isFilterChangeNeeded(farmCell.next_filter_change_date) : false;

    const pm2_5Chart = useMemo(() => {
        return(
            <FarmDialogGraph
                data={pm2_5List} label="Indicateur PM 2.5" color={'#888888'}
                ymin={0} ymax={10} unitPeriod={unitPeriod}
            />
        );
    }, [unitPeriod]);

    const pm10Chart = useMemo(() => {
        return(
            <FarmDialogGraph
                data={pm10List} label="Indicateur PM 10" color={'#888888'}
                ymin={0} ymax={10} unitPeriod={unitPeriod}
            />
        );
    }, [unitPeriod]);

    const co2Chart = useMemo(() => {
        return(
            <FarmDialogGraph
                data={co2List} label="Indicateur CO2" color={'#888888'}
                ymin={0} ymax={10} unitPeriod={unitPeriod}
            />
        );
    }, [unitPeriod]);

    const rawVocChart = useMemo(() => {
        return(
            <FarmDialogGraph
                data={rawVocList} label="Index VOC" color={'#888888'}
                ymin={0} ymax={100} unitPeriod={unitPeriod}
            />
        );
    }, [unitPeriod]);

    const isPolluted = useMemo(() => {
        // TODO Change thresholds
        return pm2_5 > 500 || pm10 > 500 || (co2 !== null && co2 > 500) || rawVoc < 100;
    }, [unitPeriod]);

    const handleFanCodeChange = (e) => {
        const fanCode = e.target.value.toUpperCase().slice(0, 8);
        setFanChangeCode(fanCode);
    };

    const handleSubmitFanCode = () => {
        postFilterChange(fanChangeCode, farmCell)
            .then(() => {
                setFanChangeFormVisible(false);
                setAlert({message: 'Le filtre a été remplacé.', status: 'success', date: new Date()});
                window.location.reload();
            })
            .catch(() => setAlert({message: 'Le code fourni est incorrect.', status: 'error', date: new Date()}));
    };

    return(
        <>
            {alert ? <AlertMessage key={alert.date} message={alert.message} status={alert.status}/> : null}

            <div className="farm__dialog_environment_blocks">
                <h2>Pollution</h2>
                <div className="farm__dialog_environment_blocks-flex">
                    {
                        isPolluted ?
                            <div className="environment-pollution-ok-nok nok">Environnement pollué</div> :
                            <div className="environment-pollution-ok-nok ok">Environnement sain</div>
                    }
                    <div className="environment-pollution-left-block">
                        <div className="environment-pollution-change-filter-block">
                            {farmCell.next_filter_change_date > 0 ?
                                <>
                                <p className="need-filter-label" style={{color: needFilterChange ? 'red' : ''}}>
                                    Changement de filtre nécessaire : {needFilterChange ? 'Oui' : 'Non'}
                                </p>
                                <p className="need-filter-change-date">
                                    {'Changement requis : ' + getFilterChangeGapFromToday(farmCell.next_filter_change_date) +
                                        ' (' + getFormattedDate(farmCell.next_filter_change_date) + ')'}
                                </p>
                                <p>
                                    {
                                        fanChangeFormVisible ?
                                        <>
                                        Entrer le code fourni par Handddle :
                                        <input type="text" value={fanChangeCode} onChange={handleFanCodeChange}
                                        placeholder="ABCD1234" style={{width: '150px'}}/>
                                        <button className="btn-white" onClick={handleSubmitFanCode}>Valider</button>
                                        </> :
                                        <button className="btn-white" onClick={() => setFanChangeFormVisible(true)}>Changer le filtre</button>
                                    }
                                </p>
                                <p>
                                </p>
                                    {/*<p className="need-filter-change-date">*/}
                                    {/*    {'Fan usage: ' + (fanUsageInSeconds !== null ? getDurationInHours(fanUsageInSeconds) : '--')}*/}
                                    {/*    <Whisper placement="bottom" trigger="hover" speaker={<Popover><span>*/}
                                    {/*      Computed on a quarter-hour basis.<br/>*/}
                                    {/*      The fan is considered in use for a quarter-hour if the average fan*/}
                                    {/*      utilization is 15% or higher,<br/>*/}
                                    {/*      equivalent to a minimum usage of 30% over half the time.*/}
                                    {/*      The final result is rounded down to the nearest hour.*/}
                                    {/*  </span></Popover>}>*/}
                                    {/*        <span>&nbsp;<MaterialIcon classes="environment-graph-legend-icon" label="info"/></span>*/}
                                    {/*    </Whisper>*/}
                                    {/*</p>*/}
                                </>
                                :
                                <>
                                    <p>No filter installed</p>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className="environment-graph-block-pollution-container">
                    <div>{pm2_5Chart}</div>
                    <div>{pm10Chart}</div>
                </div>
                <div className="environment-graph-block-pollution-container">
                    <div>{rawVocChart}</div>
                    <div>{co2List.length > 0 && co2Chart}</div>
                </div>
            </div>
        </>
    );
}
